var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide"}},[(_vm.visible)?_c('div',{staticClass:"snackbar",style:({ backgroundColor: _vm.color }),on:{"click":_vm.close}},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }